import styles from "./CreateNewPassword.module.scss";
import LanguagePicker from "../../components/LanguagePicker/LanguagePicker";
import logo from "../../assets/logo.png";
import CreatePasswordForm from "../../components/CreatePasswordForm/CreatePasswordForm";
import { useParams } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { useCreateNewPasswordCheckIdQuery } from "../../store/services/auth-api";
import { useTranslation } from "react-i18next";

const CreateNewPasswordPage = () => {
  const { id } = useParams();
  const { t } = useTranslation();

  const [authorized, setAuthorized] = useState(false);
  const { isLoading, error } = useCreateNewPasswordCheckIdQuery(
    { id: id },
    {
      skip: id ? false : true,
    }
  );


const handleCheckParam = useCallback(() => {
  // TODO: Handle real check of id from DB
  console.info(authorized, id);

  setAuthorized(id === "1");
}, [id, setAuthorized, authorized]);


  useEffect(() => {
    handleCheckParam();
  }, [id, handleCheckParam]);

  return (
    <>
      {isLoading ? (
        <div>Loading...</div>
      ) : error ? (
        <div>{t("Create Password link has been expired")}</div>
      ) : (
        <div className={styles.root}>
          <div className={styles.root_border}>
            <LanguagePicker />
          </div>
          <div className={styles.root_form}>
            <img className={styles.root_logo} src={logo} alt="Fortect logo" />
            <CreatePasswordForm expiredId={id} />
          </div>
        </div>
      )}
    </>
  );
};

export default CreateNewPasswordPage;
